import { Children, type ReactNode } from 'react';
import type { CardBackground } from '@galapagos/catalog-schema/components/Card/Card';
/** Compatibility export; the headless package owns this contract. */
export * from '@galapagos/catalog-schema/components/Card/Card';
/**
 * Split a card's children into the padded body and the foot band.
 *
 * Shared by both platforms so "the last child is the band" is decided once —
 * a rule each implementation restated separately is a rule that eventually
 * disagrees with itself.
 *
 * `body` is `undefined` rather than an empty list when the band is the only
 * child, which is what lets the shell skip the padded region entirely instead
 * of drawing an empty inset above the band.
 */
export function splitCardBand(
  children: ReactNode,
  footerBand: CardBackground | undefined,
): { body: ReactNode; band: ReactNode } {
  if (footerBand === undefined) return { body: children, band: undefined };
  const items = Children.toArray(children);
  if (items.length === 0) return { body: undefined, band: undefined };
  const body = items.slice(0, -1);
  return { body: body.length === 0 ? undefined : body, band: items.at(-1) };
}
